import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getReviewingStudentEvaluations, getClassesAssignments, getClassesSprints, setAssignment, setSprint, setEvaluation, setEvaluationSprintAndAssignment } from '../../../redux';
import Tile from '../../Components/Tile';
import { Link, useNavigate } from 'react-router-dom';
import '../../Components/dashboard.css';

function SubmittedEvaluations (props) {
    const navigate = useNavigate();
    const {
        getReviewingStudentEvaluations,
        getClassesAssignments,
        getClassesSprints,
        setEvaluationSprintAndAssignment,
        history,
        classes,
        classIndex,
        classAssignments,
        reviewingEvaluations,
        sprints,
        user,
    } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
        getReviewingStudentEvaluations(user._id);
        getClassesAssignments(user.classes);
        getClassesSprints(user.classes);
    }, []);

    const calculateIfOnTime = (dueDate) => {
        const assignmentDueDate = new Date(dueDate);
        const currentDateObject = new Date(Date.now());
        assignmentDueDate.setHours(0, 0, 0, 0);
        assignmentDueDate.setDate(assignmentDueDate.getDate() + 1);
        return currentDateObject <= assignmentDueDate;
    }

    const setAssignmentSprintEvaluationAndRedirect = (evaluation, sprint, assignment) => {
        setEvaluationSprintAndAssignment(evaluation, sprint, assignment);
        navigate("/evaluation/edit");
    }

    const getUnsubmitted = (evaluations) => {
        const unsubmittedEvaluatons = [];
        const classObject = classes[classIndex] || { name: "" }
        const assignments = classAssignments && classAssignments
            .filter(assignment => assignment.class === classObject._id)
            .sort((a, b) => {
                if (a.dueDate < b.dueDate) return -1;
                if (a.dueDate > b.dueDate) return 1;
                return 0;
            });

        for (let assignment of (assignments && assignments.filter(assignment => (
            assignment.status !== "Inactive" && !calculateIfOnTime(assignment.dueDate)
        )))) {
            const assignmentEvaluations = evaluations && evaluations.filter(evaluation => evaluation.assignment === assignment._id);
            for (let i = 0; i < assignment.evaluationsRequired - assignmentEvaluations.length; i++) {
                unsubmittedEvaluatons.push({
                    date: assignment.dueDate,
                    sprint: assignment.sprint,
                    assignment: assignment._id,
                    status: "Unsubmitted",
                })
            }
        }

        return unsubmittedEvaluatons;
    }

    const getReviews = () => {
        const sortedReviews = [...reviewingEvaluations].sort((a, b) => {
            const assignmentA = classAssignments.find(assignment => assignment._id === a.assignment);
            const assignmentB = classAssignments.find(assignment => assignment._id === b.assignment);
            if (!assignmentA || !assignmentB) return 0;
            if (assignmentA.dueDate < assignmentB.dueDate) return -1;
            if (assignmentA.dueDate > assignmentB.dueDate) return 1;
            return 0;
        });
        
        const unsubmitted = getUnsubmitted(sortedReviews);
        const submitted = sortedReviews.filter(thisEval => thisEval.status === "StudentSubmitted")
        const graded = sortedReviews.filter(thisEval => thisEval.status === "TeacherSubmitted")
        const resubmitted = sortedReviews.filter(thisEval => thisEval.status === "StudentResubmitted")
        const regraded = sortedReviews.filter(thisEval => thisEval.status === "TeacherGraded")
        const released = sortedReviews.filter(thisEval => thisEval.status === "TeacherGradedReleased")
        return {unsubmitted, submitted, graded, resubmitted, regraded, released};
    }

    const mapReviews = (evaluations) => {
        let sprint;
        let date;
        let assignment;
        let splittedName;
        let points;
        let status;
        return evaluations
            .filter(evaluation => classAssignments.find(assignment => assignment._id === evaluation.assignment))
            .map((evaluation, index) => {
                sprint = sprints.find(sprint => sprint._id === evaluation.sprint);
                date = evaluation.date.slice(5, 10).replace("-", "/");
                assignment = classAssignments.find(assignment => assignment._id === evaluation.assignment);
                if (date[0] === "0") {
                    date = date.slice(1);
                }
                splittedName = evaluation.nameOfReviewedStudent.split(",")
                if (evaluation.status === "Unsubmitted") {
                    points = "?";
                    status = "First Submission";
                } else if (evaluation.status === "StudentSubmitted") {
                    points = "?";
                    status = "First Submission";
                } else if (evaluation.status === "StudentResubmitted") {
                    points = evaluation.teacherGrade || "?";
                    status = "Revised Submission";
                } else if (evaluation.status === "TeacherGradedReleased") {
                    points = evaluation.teacherGrade || "?";
                    status = "Released Submission";
                }
                return (
                    <div className="tileContainer" key={index + "TileContainer"}>
                        <Tile
                            key={index + "Tile"}
                            number={`${splittedName[1]} ${splittedName[0][0]}.`}
                            name={assignment.name}
                            status={status}
                            dueDate={`Due ${date}`}
                            grade={`${points} out of 3`}
                            handleClick={() => setAssignmentSprintEvaluationAndRedirect(evaluation, sprint, assignment)}
                        />
                    </div>
                )
            })
    }

    const mapDisabledReviews = (evaluations) => {
        let date;
        let assignment;
        let splittedName;
        let status;
        let name;
        let grade;
        return evaluations
            .filter(evaluation => evaluation.status === "Unsubmitted" || classAssignments.find(assignment => assignment._id === evaluation.assignment))
            .map((evaluation, index) => {
                date = evaluation.date.slice(5, 10).replace("-", "/");
                assignment = classAssignments.find(assignment => assignment._id === evaluation.assignment);
                if (date[0] === "0") {
                    date = date.slice(1);
                }

                if (evaluation.status === "Unsubmitted") {
                    status = "Unsubmitted";
                    name = 'Unknown'
                    grade = '0 out of 3'
                } else {
                    splittedName = evaluation.nameOfReviewedStudent.split(",")
                    name = `${splittedName[1]} ${splittedName[0][0]}.`
                    grade = '? out of 3'

                    if (evaluation.status === "TeacherSubmitted") {
                        status = "Teacher Graded";
                    } else if (evaluation.status === "TeacherGraded") {
                        status = "Teacher Regraded";
                    }
                }
                
                return (
                    <div className="disabledTileContainer" key={index + "disabledTileContainer"}>
                        <Tile
                            key={index + "Tile"}
                            number={name}
                            name={assignment.name}
                            status={status}
                            dueDate={`Due ${date}`}
                            grade={grade}
                        />
                    </div>
                )
            })
    }

    const reviews = getReviews();
    return (
        <div className="dashboard">
            <Link to="/student" className="backButton">
                <img src={require("../../../Images/leftArrow.png")} alt="<-"/>
                Return to Dashboard
            </Link>
            <h2>These reviews are awaiting action from your teacher, or they have been finalized. To see your pending reviews or your recently-graded reviews that have been released by your teacher for resubmission, please return to the previous page.</h2>
            <div className="reviewHeaders" style={{ marginTop: "33px" }}>
                <h3 className="left" style={{ marginTop: "0px" }}>Unsubmitted Reviews</h3>
            </div>
            <h5>
                You missed the deadline for submitting these evaluations.
            </h5>
            <div className="tiles">
                {mapDisabledReviews(reviews.unsubmitted)}
            </div>
            <div className="reviewHeaders" style={{marginTop: "33px"}}>
                <h3 className="left" style={{marginTop: "0px"}}>Submitted Reviews</h3>
            </div>
            <div className="tiles">
                {mapReviews(reviews.submitted)}
            </div>
            <div className="reviewHeaders" style={{marginTop: "33px"}}>
                <h3 className="left" style={{marginTop: "0px"}}>Reviews Being Graded</h3>
            </div>
            <h5>
                You cannot view these evaluations until your teacher releases their feedback.
            </h5>
            <div className="tiles">
                {mapDisabledReviews(reviews.graded)}
            </div>
            <div className="reviewHeaders" style={{marginTop: "33px"}}>
                <h3 className="left" style={{marginTop: "0px"}}>Resubmitted Reviews</h3>
            </div>
            <div className="tiles">
                {mapReviews(reviews.resubmitted)}
            </div>
            <div className="reviewHeaders" style={{marginTop: "33px"}}>
                <h3 className="left" style={{marginTop: "0px"}}>Reviews Being Regraded</h3>
            </div>
            <h5>
                You cannot view these evaluations until your teacher releases the sprint.
            </h5>
            <div className="tiles">
                {mapDisabledReviews(reviews.regraded)}
            </div>
            <div className="reviewHeaders" style={{marginTop: "33px"}}>
                <h3 className="left" style={{marginTop: "0px"}}>Released Reviews</h3>
            </div>
            <div className="tiles">
                {mapReviews(reviews.released)}
            </div>
        </div>
    );
}

export default connect(state => state.root, { getReviewingStudentEvaluations, getClassesAssignments, getClassesSprints, setAssignment, setSprint, setEvaluation, setEvaluationSprintAndAssignment })(SubmittedEvaluations);
